
import { CreateInvoiceInfo, InvoiceNotes, SaveInvoiceInfo, SearchInvoiceInfo, SearchShareInvoiceInfo, UpdateInvoice } from "../redux/slice/invoice/InvoiceSlice";
import { InterceptorOption } from "../types/CommonTypes";
import { ADD_CREDIT_MEMO, ADD_INVOICE_NOTE_URL, ADD_INVOICE_URL, EDIT_INVOICE_URL, GET_APPLY_INVOICE_DETAIL_URL, GET_CREDIT_MEMO_DETAIL_BY_INVOICE_ID, GET_INVOICE_BY_ID_URL, LIST_INVOICE_NOTES_URL, SEARCH_INVOICE_URL, UPLOAD_INVOICE_URL ,GET_EDIT_INVOICE_DETAIL_URL, DELETE_INVOICE_AGENCY_URL, GET_INVOICES_BY_MANUFACTURER_AND_PRACTICE_URL, CREATE_INVOICE_URL ,GET_INVOICE_AGENCY_URL, PREVIEW_INVOICE_URL, STRIPE_PAYMENT_CHECKOUT_URL, STRIPE_PAYMENT_EXPIRE_SESSION_URL, UPDATE_INVOICE_STATUS_URL, ADD_LATE_FEE, GET_LATE_FEE_HISTORY_URL, BULK_PAYMENT_CHECKOUT_URL, SHARE_INVOICES_URL, SEARCH_SHARE_INVOICE_URL, GET_INVOICE_LIST_BY_PRACTICE, STRIPE_OAUTH_CONNECT_URL, STRIPE_UPFRONT_ORDER_CHECKOUT_URL, GET_PRODUCTS_WITH_OPEN_INVOICES_BY_PRACTICE_URL } from "./URL";
import { http } from "./http";

// CS-1532 - Start
export interface UpdateInvoiceStatus {
  invoiceId: number;
  mfgInvoiceStatus: string;
}
// CS-1532 - End

export const getInvoiceList = async (data: SearchInvoiceInfo, skipLoader: boolean = false) => {
  try {
    const response = skipLoader
      ? await http.post(SEARCH_INVOICE_URL, data, { headers: { "x-skip-loader": "true" } })
      : await http.post(SEARCH_INVOICE_URL, data);
    return response;
  } catch (error) {
    throw error;
  }
};

// CS-1995 - fetch products that have open (PARTIAL/UNPAID) invoices for a practice and a Stripe-enabled MFR
export const fetchProductsWithOpenInvoicesByPractice = async (practiceId: number) => {
  try {
    const response = await http.get(`${GET_PRODUCTS_WITH_OPEN_INVOICES_BY_PRACTICE_URL}?practiceId=${practiceId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getShareInvoiceList = async (data: SearchShareInvoiceInfo) => {
  try {
    const response = await http.post(SEARCH_SHARE_INVOICE_URL, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const saveInvoice = async (data: SaveInvoiceInfo, interceptorOption: InterceptorOption) => {
  try {
    const response = await http.post(ADD_INVOICE_URL, data, undefined, interceptorOption);
    return response;
  } catch (error) {
    throw error;
  }
};

//CS-1322 - Start
export const createInvoiceService = async (data: CreateInvoiceInfo, interceptorOption: InterceptorOption) => {
  try {
    const response = await http.post(CREATE_INVOICE_URL, data, undefined, interceptorOption);
    return response;
  } catch (error) {
    throw error;
  }
}
export const previewInvoiceService = async (invoiceId: number, interceptorOption: InterceptorOption) => {
  try {
    const response = await http.get(`${PREVIEW_INVOICE_URL}/${invoiceId}`, undefined, interceptorOption);
    return response;
  } catch (error) {
    throw error;
  }
}

// task cs-647 start
export const updateInvoiceData = async (invoice: UpdateInvoice, interceptorOption: InterceptorOption) => {
    try{
        const response = await http.post(EDIT_INVOICE_URL,invoice,undefined,interceptorOption);
        return response;
    }
    catch(error){
        throw error;
    }
};
// task cs-647 End

export const getInvoiceFromId = async ({invoiceId, isSaveAuditLog, skipLoader = false }: {invoiceId: number; isSaveAuditLog: boolean; skipLoader?: boolean }) => {
  try {
    const response = await http.get(
      `${GET_INVOICE_BY_ID_URL}?invoiceId=${invoiceId}&isSaveAuditLog=${isSaveAuditLog}`,
      {
        headers: {
          ...(skipLoader && { 'x-skip-loader': 'true' }),
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getInvoiceFromIdLoadingGifSkipped = async (invoiceId: number, isSaveAuditLog: boolean, headers: Record<string, string>) => {
  try {
    const response = await http.get(`${GET_INVOICE_BY_ID_URL}?invoiceId=${invoiceId}&isSaveAuditLog=${isSaveAuditLog}`, {headers: {...headers}});
    return response;
  } catch (error) {
    throw error;
  }
};



export const uploadInvoice = async (data: PaymentRequest, interceptorOption?: InterceptorOption) => {
  try {
    const response = await http.post(UPLOAD_INVOICE_URL, data, undefined, interceptorOption);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCreditMemoDetailsByInvId = async (invId: number) => {
  try {
      const response = await http.get(GET_CREDIT_MEMO_DETAIL_BY_INVOICE_ID +`/${invId}`);
      return response
  } catch (error) {
      throw error;
  }
}
export const addCreditMemoData = async (data: any) => {
  try {
      const response = await http.post(ADD_CREDIT_MEMO,data);
      return response
  } catch (error) {
      throw error;
  }
}

//CS-1212 - Start
export const uploadInvoiceNotesData = async (ivrNotesObjecct: InvoiceNotes) => {
  try {
    const response = await http.post(ADD_INVOICE_NOTE_URL, ivrNotesObjecct);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getInvoiceNoteById = async (xrefTableId: number, xrefTable: any) => {
  try {
    const response = await http.post(LIST_INVOICE_NOTES_URL, null, {
      params: {
        xrefTableId,
        xrefTable,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
}
//CS-1212 - End

//CS-1191 - Start
export const getApplyInvDetailByPracticeAndProductId = async (data: any) => {
  try {
      const response = await http.get(`${GET_APPLY_INVOICE_DETAIL_URL}?practiceId=${data.practiceId}&productId=${data.productId}`);
      return response
  } catch (error) {
      throw error;
  }
}
export const getEditInvoiceDetailByInvId = async (invId: any) => {
  try {
      const response = await http.get(`${GET_EDIT_INVOICE_DETAIL_URL}?invoiceId=${invId}`);
      return response
  } catch (error) {
      throw error;
  }
}
export const deleteSpecificInvoiceAgencyById = async (id: any) => {
  try {
      const response = await http.delete(`${DELETE_INVOICE_AGENCY_URL}?invoiceAgencyId=${id}`);
      return response
  } catch (error) {
      throw error;
  }
}
//CS-1191 - End

// CS - 1216 Start
export const getInvoiceByManufacturerIdAndPracticeId = async (data: any, headers: Record<string, string>) => {
  try {
    const response = await http.get(`${GET_INVOICES_BY_MANUFACTURER_AND_PRACTICE_URL}?manufacturerId=${data.manufacturerId}&practiceId=${data.practiceId}`, {
      headers: {
        ...headers,
      },
    });
    return response
  } catch (error) {
    throw error;
  }
}
// CS - 1216 End
// export const genrateStripeAccountKey = async (data: any) => {
//   try {
//     const response = await http.post(STRIPE_PAYMENT_SERVICE_URL , data);
//     return response
//   } catch (error) {
//     throw error;
//   }
// }
export const stripeCheckout = async (data: any, skipLoader: boolean = false) => {
  try {
    const response = skipLoader
      ? await http.post(STRIPE_PAYMENT_CHECKOUT_URL, data, { headers: { "x-skip-loader": "true" } })
      : await http.post(STRIPE_PAYMENT_CHECKOUT_URL, data);
    return response
  } catch (error) {
    throw error;
  }
}

// CS-1845 - Upfront order checkout: dedicated endpoint for pay-now flow on order creation
export interface UpfrontOrderCheckoutRequest {
  orderId: number;
  paymentMethod: string;
  successUrl: string;
  cancelUrl: string;
}

export const stripeUpfrontOrderCheckout = async (data: UpfrontOrderCheckoutRequest) => {
  try {
    const response = await http.post(STRIPE_UPFRONT_ORDER_CHECKOUT_URL, data);
    return response;
  } catch (error) {
    throw error;
  }
};

//CS-1682 - Bulk Payment Checkout
export const bulkPaymentCheckout = async (data: any) => {
  try {
    const response = await http.post(BULK_PAYMENT_CHECKOUT_URL , data);
    return response
  } catch (error) {
    throw error;
  }
}
//CS-1576 - Update expire session function to handle logic for connected accounts also
export const stripeCheckoutSessionExpire = async (data: string) => {
  try {
    const response = await http.post(STRIPE_PAYMENT_EXPIRE_SESSION_URL, data );
    return response
  } catch (error) {
    throw error;
  }
}
// CS - 1216 End=======
// CS - 1216 End

// CS - 1384 START
export const getInvoiceAgencyByInvoiceId = async (invoiceId: number, skipLoader: boolean = false) => {
  try {
    const url = `${GET_INVOICE_AGENCY_URL}?invoiceId=${invoiceId}`;
    const response = skipLoader
      ? await http.get(url, { headers: { "x-skip-loader": "true" } })
      : await http.get(url);
    return response;
  } catch (error) {
    throw error;
  }
}
// CS - 1384 END

// CS-1532 - Start
export const updateInvoiceStatusData = async (
  invoiceStatus: UpdateInvoiceStatus,
  interceptorOption: InterceptorOption
) => {
  try {
    const response = await http.post(UPDATE_INVOICE_STATUS_URL, invoiceStatus, undefined, interceptorOption);
    return response;
  } catch (error) {
    throw error;
  }
};
// CS-1532 - End

// CS-1583 - START
export const addLateFeeByInvoiceId = async (invoiceId:string | number,lateFee: string | number, headers: Record<string, string>) => {
  try {
    console.log("skip Loader:          ", {...headers})
      const response = await http.post(`${ADD_LATE_FEE}?invoiceId=${invoiceId}&lateFee=${lateFee}`, {headers: {...headers}});
      return response
  } catch (error) {
      throw error;
  }
}
// CS-1583 - END

export const getLateFeeHistoryByInvoiceId = async (invoiceId: number) => {
  try {
    const response = await http.get(`${GET_LATE_FEE_HISTORY_URL}?invoiceId=${invoiceId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// CS-1666 - START
export interface ShareInvoiceRequest {
  subject: string;
  customMessage: string;
  invoiceShareDetailList: InvoiceShareDetail[];
}

export interface InvoiceShareDetail {
  invoiceId: number;
  emails: string[];
}

export const shareInvoices = async (data: ShareInvoiceRequest, interceptorOption?: InterceptorOption) => {
  try {
    const response = await http.post(SHARE_INVOICES_URL, data, undefined, interceptorOption);
    return response;
  } catch (error) {
    throw error;
  }
};
// CS-1666 - END

export const fetchInvoicesByPractice = async (practiceId: number) => {
  try {
    const response = await http.get(`${GET_INVOICE_LIST_BY_PRACTICE}?practiceId=${practiceId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// CS-1750 - Start
export const stripeOAuthConnect = async (code: string) => {
  try {
    const response = await http.get(`${STRIPE_OAUTH_CONNECT_URL}?code=${code}`);
    return response;
  } catch (error) {
    throw error;
  }
};
// CS-1750 - End
